import React, { useState } from 'react';

import { Backdrop, Button, ButtonGroup } from '@material-ui/core';
import { RotateLeft as IconRotateLeft, RotateRight as IconRotateRight } from '@material-ui/icons';

type Props = {
	urlOriginal: string,
	urlEdited?: string,
	expandable?: boolean
};

export const Photo = (props: Props) => {
	const [selectedImage, setSelectedImage] = useState<string>(props.urlEdited || props.urlOriginal);
	const [isExpandedViewOpen, setIsExpandedViewOpen] = useState<boolean>(false);
	const [isFullScreenOpen, setIsFullScreenOpen] = useState<boolean>(false);
	const [rotationAngle, setRotationAngle] = useState<number>(0);
	
	return (
		<div className="photo">
			<img src={selectedImage} alt="" className={(props.expandable === false ? '' : 'pointer') + ' ' + (isExpandedViewOpen === true ? 'expanded' : 'condensed')} onClick={props.expandable === false ? undefined : () => setIsExpandedViewOpen(!isExpandedViewOpen)} />
			<Button variant="contained" color="default" className="top-left" onClick={() => setIsFullScreenOpen(true)}>View in Fullscreen</Button>
			{
				isExpandedViewOpen === false && (
					selectedImage === props.urlEdited ? (
						<Button variant="contained" color="default" className="top-right" onClick={() => setSelectedImage(props.urlOriginal)}>Switch to Original</Button>
					) :
					props.urlEdited !== undefined && (
						<Button variant="contained" color="default" className="top-right" onClick={() => setSelectedImage(props.urlEdited!)}>Switch to Edited</Button>
					)
				)
			}
			<Backdrop open={isFullScreenOpen} className="backdrop">
				<div>
					<img src={selectedImage} alt="" style={{ transform: 'rotate(' + rotationAngle + 'deg)' }} />
					<ButtonGroup style={{ position: 'absolute', top: 10, right: 10 }}>
						<Button variant="contained" color="default" href={selectedImage} target="_blank">Open in New Window</Button>
						<Button variant="contained" color="default" onClick={() => setIsFullScreenOpen(false)}>Close</Button>
					</ButtonGroup>
					<ButtonGroup style={{ position: 'absolute', bottom: 10, right: 10 }}>
						<Button variant="contained" color="default" endIcon={<IconRotateLeft />} onClick={() => setRotationAngle(rotationAngle - 90)}>Rotate</Button>
						<Button variant="contained" color="default" endIcon={<IconRotateRight />} onClick={() => setRotationAngle(rotationAngle + 90)}>Rotate</Button>
					</ButtonGroup>
				</div>
			</Backdrop>
		</div>
	);
};